/* Header cart badge — HEllO EDC (India store). Fourth pass, 24 Oct 2026.

   WHAT THE BADGE SHOULD SAY
   A strap and its fitted buckle are two Shopify cart lines joined by a hidden
   _wc_group property. To the shopper they are one thing, so the badge counts
   everything except lines marked _wc_role = buckle.

   WHO WRITES THE WRONG NUMBER (found in the browser, 24 Oct 2026)
   The FoxKit Upsell & Bundles app (its main.js, updateCartCount) writes
   Shopify's raw cart.item_count into .cart-count-bubble after every add, and
   when it does it rebuilds the number as a plain <span> without
   aria-hidden — which is why the previous version of this file, which only
   looked for span[aria-hidden="true"], never saw it and the badge read 2 for
   one strap.

   WHAT THIS FILE DOES
   - Knows the right number: reads /cart.js on load and again after every
     cart request any script makes (fetch or XHR to /cart/...).
   - Holds it: whenever any badge on the page shows something else, puts the
     right number back on the next animation frame. Watches the whole page,
     plus a heartbeat, so an app replacing the icon outright is still caught.
   - Only writes when the shown number is wrong, so it never loops. */

(function () {
  'use strict';

  if (window.__wcCartCount) return;
  window.__wcCartCount = true;

  var HEARTBEAT_MS = 700;
  var MARK = 'X-WC-Cart-Count';

  var visible = null;     /* strap-only total: what the badge should say */
  var frame = null;
  var timer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* The visible number inside a badge: the first span that is not the
     screen-reader text. Works for the theme's markup and FoxKit's. */
  function numberEl(bubble) {
    var spans = bubble.querySelectorAll('span');
    for (var i = 0; i < spans.length; i++) {
      if (!spans[i].classList.contains('visually-hidden')) return spans[i];
    }
    return null;
  }

  function paint() {
    if (visible === null) return;
    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      var el = numberEl(bubble);
      var want = String(visible);
      if (el && el.textContent.trim() !== want) el.textContent = want;
      var sr = bubble.querySelector('.visually-hidden');
      var srWant = visible + (visible === 1 ? ' item' : ' items');
      if (sr && sr.textContent.trim() !== srWant) sr.textContent = srWant;
      /* An empty cart shows no badge, as the theme does. */
      var hide = visible === 0;
      if (hide && bubble.style.display !== 'none') bubble.style.display = 'none';
      if (!hide && bubble.style.display === 'none') bubble.style.display = '';
    });
  }

  function requestPaint() {
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = null;
      try { paint(); } catch (e) { /* no-op */ }
    });
  }

  function refresh() {
    var h = {}; h[MARK] = '1';
    return nativeFetch.call(window, root() + 'cart.js', { credentials: 'same-origin', headers: h })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var v = 0;
        cart.items.forEach(function (item) {
          var p = item.properties || {};
          if (p._wc_role === 'buckle') return;
          v += item.quantity;
        });
        visible = v;
        requestPaint();
      })
      .catch(function () { /* leave the badge as it is */ });
  }

  function soon(ms) {
    clearTimeout(timer);
    timer = setTimeout(refresh, ms == null ? 150 : ms);
  }

  function isCartWrite(url) {
    url = String(url || '');
    return url.indexOf('/cart/') > -1 && url.indexOf('cart.js') === -1;
  }

  /* Re-read the cart after any script changes it. */
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var out = nativeFetch.apply(this, arguments);
      if (isCartWrite(url)) out.then(function () { soon(); }, function () {});
      return out;
    };
  }
  var xOpen = window.XMLHttpRequest && window.XMLHttpRequest.prototype.open;
  if (xOpen) {
    window.XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartWrite(url)) this.addEventListener('loadend', function () { soon(); });
      return xOpen.apply(this, arguments);
    };
  }

  function start() {
    refresh();
    try {
      new MutationObserver(requestPaint).observe(document.body, { childList: true, subtree: true, characterData: true });
    } catch (e) { /* no-op */ }
    setInterval(paint, HEARTBEAT_MS);
    ['cart:refresh', 'cart:updated', 'wc:cart-synced'].forEach(function (evt) {
      document.addEventListener(evt, function () { soon(); });
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
